import { useTranslation } from "react-i18next";
import { useSubmitCatalogueFormMutation } from "../api/catalogueApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";
import type {
  CatalogueFormPayload,
  CatalogueFormResponse,
} from "../types/catalogueApiTypes";

export const useSubmitCatalogueForm = () => {
  const { t } = useTranslation();
  const [submitMutation, result] = useSubmitCatalogueFormMutation();

  const {
    trigger: submitCatalogueForm,
    isLoading,
    isSuccess,
  } = useMutationWithFeedback<CatalogueFormResponse, CatalogueFormPayload>({
    mutation: [submitMutation, result],
    loadingMessage: t("catalogueForm.sending", "Talebiniz gönderiliyor..."),
    successMessage: t(
      "catalogueForm.success",
      "Katalog talebiniz başarıyla alındı."
    ),
    errorMessages: {
      default: t("catalogueForm.error", "İşlem sırasında bir hata oluştu."),
    },
  });

  return {
    submitCatalogueForm,
    isLoading,
    isSuccess,
    isError: result.isError,
  };
};
